import { useState } from "react";
import search from "../assets/svg/search.png";
import heroImg from "../assets/images/bg4.png"
const Hero = ({ handleSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch(searchTerm);
    // Redirect to search page or any other page as needed
    // history.push(`/search?query=${searchTerm}`);
  };

  return (
    <div
      className="w-full h-[500px] overflow-hidden bg-no-repeat bg-image{heroImg}"
      style={{
        background: `url(${heroImg}) center, no-repeat`,
        backgroundSize: "cover",
      }}
    >
      <div className="md-down:mt-[63px] text-center mt-[55px] max-w-[1100px] mx-auto">
        <h2 className="text-[#fff] text-[50px] md-down:text-[30px] md-down:mx-2 font-bold">
          Run advertisement for <br className="md-down:hidden" /> your<span className="text-[#F6D200]"> Business</span>
        </h2>
        <p className="text-[18px] max-w-[400px] mx-auto text-white text-center">
          <span className="font-semibold">Swift Mart</span> is here to make your business go public,
          at the price you want, in the style you want <br className="md-down:hidden" /> Send us a message with the button below.
        </p>

        <button data-hs-form="23fec29d-236d-47ad-868a-a487846df9fc" type="button" data-hs-modal className="hs-show py-2 px-5 bg-[#F6D200] text-white rounded-lg mt-5 md-down:max-w-[200px] md-down:mx-auto">
         <a href="https://share-eu1.hsforms.com/1I_7CnSNtR62GiqSHhG35_A2e22mt" target="_blank">Run Ads</a></button>
      </div>

    </div>
  );
}

export default Hero;